import React from 'react'
import { Flex } from 'components/ds'
import { FlexProps } from '@radix-ui/themes'

type CircleProps = FlexProps & {
  color?: string
  radius?: string
  children?: React.ReactNode
  subtle?: boolean
  style?: Record<string, string>
}

/**
 * A circular container component with customizable color, size, and styling
 * @param color - The color theme for the circle background - defaults to 'gray'
 * @param radius - The diameter of the circle (CSS dimension) - defaults to '96px'
 * @param subtle - Whether to use a subtle color variant (lighter shade) - defaults to false
 * @param style - Additional CSS styles to apply to the circle - defaults to {}
 * @param children - Content to render inside the circle
 * @param rest - Additional props passed to the underlying Flex component
 * @returns A Flex component styled as a circle with centered content
 */
const Circle = ({
  color = 'gray',
  radius = '96px',
  subtle = false,
  style = {},
  children,
  ...rest
}: CircleProps) => {
  const iconColor = subtle ? `${color}-4` : `${color}-9`
  return (
    <Flex
      style={{
        backgroundColor: `var(--${iconColor})`,
        width: radius,
        height: radius,
        borderRadius: '50%',
        ...style,
      }}
      align="center"
      justify="center"
      {...rest}
    >
      {children}
    </Flex>
  )
}

export default Circle
